<template>
  <v-app>
    <MaintenanceOverlay v-if="maintenanceActive" />
    <template v-else>
      <ViewAsBanner />
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="appShellInstanceKey(route)" />
      </router-view>
      <GlobalNotificationHost />
      <SchemaMismatchDialog />
    </template>
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

// Imported eagerly, unlike other dialogs: the stale bundle it serves may name
// chunks the new release no longer has.
import SchemaMismatchDialog from "@/components/common/SchemaMismatchDialog.vue";
import GlobalNotificationHost from "@/core/api/GlobalNotificationHost.vue";
import { maintenanceActive, markMaintenanceActive } from "@/core/api/maintenanceState";
import MaintenanceOverlay from "@/core/components/MaintenanceOverlay.vue";
import ViewAsBanner from "@/core/components/ViewAsBanner.vue";
import { maintenanceService } from "@/core/services/maintenanceService";
import { appShellInstanceKey } from "@/router/routeIdentity";

// Check the maintenance flag on load so the "back soon" page shows immediately
// while logins are blocked, rather than only after a failed write (#2343). Any
// later blocked call also latches it via the shared API layer. Best-effort: a
// failed status probe just leaves the app in normal mode.
onMounted(async () => {
  try {
    const status = await maintenanceService.getStatus();
    if (status.maintenance) {
      markMaintenanceActive();
    }
  } catch {
    // ignore: the status endpoint is a courtesy, not a gate
  }
});
</script>
